<!--网络异常组件-->
<template>
  <transition name="el-fade-in">
    <div class="network-error">
      <div class="network-error-content">
        <span class="icon" />
        <div class="txt">
          <span>{{ errorTip }}</span>
          <button v-if="showBtn" @click="btnClickFn">{{ btnText }}</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { aisearchReportData } from "@/services/modules/ai_search";
export default {
  name: "NetworkError",
  props: {
    errorTip: {
      type: String,
      default: "暂无数据",
    },
    btnText: {
      type: String,
      default: "刷新",
    },
    btnClickFn: {
      type: Function,
      default: () => {},
    },
    errorType: {
      // 网络错误：2; 超时：1
      type: Number,
      default: 0,
    },
    showBtn: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    if (this.errorType === 2) {
      aisearchReportData("show", "AISearch_Result_Error_page", "", [
        {
          key: "param2",
          value: JSON.stringify({
            engine: this.$store.state.aisearch.currentSearchCode || 'baidu',
            type: 3,
          }),
        },
        {
          key: 'param3',
          value: JSON.stringify({
            pageversion: this.searchVersion,
          }),
        },
      ]);
    } else if (this.errorType === 1) {
      aisearchReportData("show", "AISearch_Result_Error_page", "", [
        {
          key: "param2",
          value: JSON.stringify({
            engine: this.$store.state.aisearch.currentSearchCode || 'baidu',
            type: 2,
          }),
        },
        {
          key: 'param3',
          value: JSON.stringify({
            pageversion: this.searchVersion,
          }),
        },
      ]);
    }
    // 搜索结果-错误页曝光
    aisearchReportData('SLB_NewTabPage', 'AISearch_Result_Error_page', 'show', undefined, true);
  },
  methods: {
    /**
     * 发送刷新事件
     */
    onRefresh() {
      this.$emit("onRefresh");
    },
  },
};
</script>

<style lang="scss" scoped>
.network-error {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
}
.network-error-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    display: block;
    width: 100px;
    height: 100px;
    margin-bottom: 12px;
  }
  .icon {
    display: block;
    width: 100px;
    height: 100px;
    margin-bottom: 12px;
    background-image: url(@/assets/images/common/empty.svg);
    background-size: cover;
    background-repeat: no-repeat;
  }
  .txt {
    span {
      color: var(--text2, #615e83);
      text-align: center;
      font-family: HYQiHei;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; /* 142.857% */
    }
    button {
      display: flex;
      padding: 5px 24px;
      justify-content: center;
      align-items: center;
      border-radius: 12px;
      border: 1px solid rgba(0, 0, 0, 0.02);
      background: rgba(255, 255, 255, 0.6);
      color: rgba(97, 94, 131, 0.7);
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      margin: 0 auto;
      margin-top: 20px;
      &:hover,
      &:active {
        background: rgba(255, 255, 255, 0.4);
        color: #4e4b69;
      }
    }
  }
}
</style>
